var React = require('react');

function Check (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"d":"M8.654 18.374L7.279 17 4 13.8l1.41-1.41 3.28 3.2.355.356 4.234-4.234 1.41-1.41L18.98 6l1.41 1.41-4.29 4.302-1.41 1.41-5.712 5.613-.323-.36z","id":"ic_check_svg__a"})),React.createElement("use",{"fill":"#000","xlinkHref":"#ic_check_svg__a","fillRule":"evenodd","key":1})]);
}

Check.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24"};

module.exports = Check;

Check.default = Check;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/common/svg/icons/check.svg
// module id = 1472
// module chunks = 0